import L, { get, latLngBounds, openOn, zoomOntoMarker, latLng } from "leaflet";

export const sortByDistance = (selectedGeoAdress, data) => {
  const addressLtnLgn = L.latLng(
    parseFloat(selectedGeoAdress.geometry.coordinates[1]),
    parseFloat(selectedGeoAdress.geometry.coordinates[0])
  );

  let entitiesWithDistances = data.map((entity) => {
    const entityLatLng = L.latLng(
      parseFloat(entity.latitude),
      parseFloat(entity.longitude)
    );

    const distance = addressLtnLgn.distanceTo(entityLatLng) / 1000;

    return { ...entity, distance: distance };
  });

  entitiesWithDistances = entitiesWithDistances.sort((a, b) =>
    a.distance > b.distance ? 1 : b.distance > a.distance ? -1 : 0
  );

  return entitiesWithDistances;
};
